export let stg = {
    coin               : '$',
    coin_space         : '1',
    decimals_visible   : 2,
    decimals_separator : '.',
    thousands_separator: ',',
    url_uploads        : '', // se obtiene del verify
    country_code       : 'PE',
};

export function setStg(newStg) {
    stg = newStg;
}

export function coin(value) {
    return Util.coin(value);
}

export function pair(id, name) {
    return {id, name};
}

export function number_format(value, decimals = null) {
    let number = Number(value) || 0;

    let strAmount = (decimals == null
        ? number.toString()
        : number.toFixed(decimals));

    let amountParts = strAmount.split('.');

    strAmount = amountParts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + stg.thousands_separator);

    if (amountParts.length >= 2) {
        strAmount += stg.decimals_separator + amountParts[1];
    }

    return strAmount;
}

export default class Util {

    static loading(show) {
        /*if (show) {

            if (typeof show === 'string') {
                $loading_text.innerHTML = show;
            } else {
                $loading_text.innerHTML = __('loading') || 'Cargando...';
            }
            //$loading.style.display = 'block';
            $loading.classList.add('visi');

        } else {
            //$loading.style.display = 'none';
            $loading.classList.remove('visi');
        }*/

    }

    static coin(value) {
        return stg.coin + (stg.coin_space === '1' ? ' ' : '') + Util.coinFormat(value);
    }

    static coinFormat(value) {
        return number_format(value, stg.decimals_visible);
    }
}

export function flagEmoji(countryCode) {
    const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map(char => 127397 + char.charCodeAt());
    return String.fromCodePoint(...codePoints);
}